import * as React from 'react'
import { Flag, FlagType, DynamicCx } from 'common/types'
import { styling } from 'common/utils'
import * as s from './lnb.scss'

interface OwnProps {
  flag: Flag
  cx?: DynamicCx
}

type Props = OwnProps

const Flag: React.SFC<Props> = ({ flag, cx }) => {
  const { type, className } = flag
  switch (type) {
    case FlagType.NEW:
    case FlagType.BETA:
    case FlagType.SEPARATION:
      return <i className={cx(className)}>{type}</i>
  }
}

const styled = styling(s)(Flag)
export default styled
